import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

import { MenuList } from "../cards/menu-list";
import { formatUrl } from "../../helpers/parse-url";


export const AuthorInfo = ({ 
    post, 
    indx,
    handleDelete,
    closeMenu,
    userData,
    selectPost,
    postMenu 
}) => {

    const navigateTo = useNavigate();

    return (
        <div className='author-info'>
            <img
                src={formatUrl(post?.author?.avatar)}
                className='author-avatar'
                alt=''
            />
            <div className='author-name'>
                {post?.author?.username}
            </div>
            <div className="action-box">
                <button
                    className="tr-btn"
                    onClick={selectPost}
                >
                    <FontAwesomeIcon icon={faEllipsisVertical} />
                </button>

            </div>
            {postMenu === indx &&
                <MenuList
                    authorized={post?.author._id === userData?._id}
                    otherUser={post?.author._id !== userData?._id}
                    closeMenu={closeMenu}
                    deleteMethod={handleDelete}
                    onEdit={() => {
                        navigateTo("/globalmedic/editdiscussion", {
                            state: {
                                post
                            }
                        })
                    }}

                />}
        </div>
    )
}